<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc" id="toc"><h1>Contents</h1><ol><li id="level1-titlepage"><span href="#/titlepage" title="Link target outside of Sample">Title Page</span></li>
<li id="level1-toc"><a href="#/toc">Contents</a></li>
<li id="level1-front3"><a href="#/front01">Copyright</a></li>
<li id="level1-front4"><a href="#/front02">Dedication</a></li>
<li id="level1-front5"><a href="#/front03">Epigraph</a></li>
<li id="level1-front6"><a href="#/front04">Maps of Area</a></li>
<li id="c01"><a href="#/c01">Among the Unreal People</a>
</li>
<li id="c02"><a href="#/c02">The Train from Khayelitsha</a>
</li>
<li id="c03"><span href="#/c03" title="Link target outside of Sample"><em>Cape Town</em>: The Spirit of the Cape</span>
</li>
<li id="c04"><span href="#/c04" title="Link target outside of Sample">The Night Bus to Windhoek</span>
</li>
<li id="c05"><span href="#/c05" title="Link target outside of Sample">Night Train from Swakopmund</span>
</li>
<li id="c06"><span href="#/c06" title="Link target outside of Sample">The Bush Track to Tsumkwe</span>
</li>
<li id="c07"><span href="#/c07" title="Link target outside of Sample">Ceremony at the Crossroads</span>
</li>
<li id="c08"><span href="#/c08" title="Link target outside of Sample">Among the Real People</span>
</li>
<li id="c09"><span href="#/c09" title="Link target outside of Sample">Riding an Elephant: The Ultimate Safari</span>
</li>
<li id="c10"><span href="#/c10" title="Link target outside of Sample">The Hungry Herds at Etosha</span>
</li>
<li id="c11"><span href="#/c11" title="Link target outside of Sample">The Frontier of Bad Karma</span>
</li>
<li id="c12"><span href="#/c12" title="Link target outside of Sample">Three Pieces of Chicken</span>
</li>
<li id="c13"><span href="#/c13" title="Link target outside of Sample">Volunteering in Lubango</span>
</li>
<li id="c14"><span href="#/c14" title="Link target outside of Sample">The Slave Yards of Benguela</span>
</li>
<li id="c15"><span href="#/c15" title="Link target outside of Sample">Luanda: The Improvised City</span>
</li>
<li id="c16"><span href="#/c16" title="Link target outside of Sample">“This Is What the World Will Look Like When It Ends”</span>
</li>
<li id="c17"><span href="#/c17" title="Link target outside of Sample">What Am I Doing Here?</span>
</li>
<li id="level1-back41"><span href="#/back01" title="Link target outside of Sample">Coming Soon from Paul Theroux</span></li>
<li id="level1-back42"><span href="#/back02" title="Link target outside of Sample">Read More from Paul Theroux</span></li>
<li id="level1-back43"><span href="#/back03" title="Link target outside of Sample">About the Author</span></li>
<li id="level1-footnotes"><span href="#/footnotes" title="Link target outside of Sample">Footnotes</span></li></ol></nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?2841586f